import { match } from 'ts-pattern'
import i18next from 'i18next'
import type { DepartmentMutator } from '@/lib/entity/department'
import type { Converter } from '@/lib/converter/entityFormatter'
import { asModifiedField } from '@/lib/converter/entityFormatter'

type DepartmentSchema = DepartmentMutator['merged']

export const DepartmentConverter: Converter<DepartmentSchema> = {
  icon: () => i18next.t('stages.icon.department'),
  title: () => i18next.t('stages.table.department'),
  subTitle: async (merged) => merged.name ?? i18next.t('ui.common.inputting'),
  modifiedFields: (modified, column) => {
    const label = i18next.t(`stages.labels.department.${column}`)
    return match(column)
      .with('name', (column) => asModifiedField(label, modified[column]!))
      .with('id', 'order', () => undefined)
      .exhaustive()
  }
}
